/**
 * MT Product Stick - 产品粘性栏功能
 * 修复版：增强了按钮查找逻辑，确保能触发加入购物车
 * 升级版：兼容并优先使用悬浮窗内部的多属性与数量选择器
 */

(function() {
  'use strict';

  function initProductStick(config) {
    const {
      mainFormSelector,
      submitButtonSelector,
      quantityInputSelector,
      sourceImageSelector,
      stickyButtonId,
      buyNowLinkId,
      productFormId,
      defaultVariantId,
      defaultImageUrl,
      cartUrl,
      currencyCode,
      productFormIdForPicker
    } = config;

    const mainForm = document.querySelector(mainFormSelector);
    if (!mainForm) {
      console.error('MT ATC: 找不到主表单 (Main form not found):', mainFormSelector);
    }

    const stickyButton = document.querySelector(stickyButtonId);
    const buyNowLink = document.querySelector(buyNowLinkId);
    const priceElement = document.querySelector('.mt-product-current-price');
    const comparePriceElement = document.querySelector('.mt-product-compare-price');
    const productImage = document.querySelector('.mt-product-stick-img');

    // 升级：优先获取悬浮窗内的数量输入框，若无则获取主表单的
    function getQuantityInput() {
      const localStickyQty = document.querySelector('.mt-sticky-qty');
      if (localStickyQty) return localStickyQty;

      if (!quantityInputSelector) return null;
      let customInput = document.querySelector(quantityInputSelector);
      if (customInput) return customInput;
      if (mainForm) return mainForm.querySelector(quantityInputSelector);
      return null;
    }

    function getCurrentQuantity() {
      const quantityInput = getQuantityInput();
      if (quantityInput && quantityInput.value) {
        const quantity = parseInt(quantityInput.value, 10);
        return isNaN(quantity) || quantity < 1 ? 1 : quantity;
      }
      return 1;
    }

    function triggerMainFormSubmit() {
      let mainVariantInput = null;
      if (mainForm) {
        mainVariantInput = mainForm.querySelector('input[name="id"]');
      }

      // 升级：优先读取全局变量 (由 Liquid 的 inline JS 在选购时赋值)
      let targetId = window.mtStickySelectedVariantId;
      if (!targetId) {
        const variant = getCurrentVariantFromPicker();
        targetId = (variant && variant.id) ? variant.id : defaultVariantId;
      }

      // 同步 Variant ID 到主表单
      if (!mainVariantInput || !mainVariantInput.value) {
        if (targetId) {
          if (!mainVariantInput && mainForm) {
            mainVariantInput = document.createElement('input');
            mainVariantInput.type = 'hidden';
            mainVariantInput.name = 'id';
            mainForm.appendChild(mainVariantInput);
          }
          if (mainVariantInput) {
             mainVariantInput.value = targetId;
             updateVariantId(targetId);
          }
        }
      } else if (mainVariantInput && targetId) {
         mainVariantInput.value = targetId; // 确保强制覆盖为主表单值
      }

      if (mainVariantInput && mainVariantInput.disabled) {
        mainVariantInput.disabled = false;
      }

      // 同步数量到主表单（如果悬浮窗有独立数量框）
      const mainQuantityInput = mainForm ? mainForm.querySelector(quantityInputSelector) : null;
      if (mainQuantityInput) {
        const qty = getCurrentQuantity();
        mainQuantityInput.value = qty;
        mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // 查找并触发主按钮点击
      let mainSubmitButton = null;
      if (submitButtonSelector) {
        mainSubmitButton = document.querySelector(submitButtonSelector);
      }
      if (mainSubmitButton && mainSubmitButton.tagName === 'FORM') {
        mainSubmitButton = mainSubmitButton.querySelector('button[name="add"], button[type="submit"], input[type="submit"]');
      }
      if (!mainSubmitButton && mainForm) {
        mainSubmitButton = mainForm.querySelector('button[name="add"]') || 
                           mainForm.querySelector('button[type="submit"]') ||
                           mainForm.querySelector('.product-form__submit');
      }

      if (mainSubmitButton) {
        if (mainSubmitButton.disabled) console.warn('MT ATC: 原始加入购物车按钮处于禁用状态');
        mainSubmitButton.click();
      } else {
        console.error('MT ATC: 无法找到主加购按钮。尝试直接提交表单。');
        if (mainForm) mainForm.submit();
      }
    }

    function updateBuyNowLink(variantId) {
      if (buyNowLink && variantId) {
        const quantity = getCurrentQuantity();
        buyNowLink.href = cartUrl + '/' + variantId + ':' + quantity + '?checkout';
      }
    }

    function formatMoney(cents) {
      if (!cents) return '';
      if (window.themeVariables && window.themeVariables.settings.moneyFormat) {
        const format = window.themeVariables.settings.moneyFormat;
        const amount = (cents / 100).toFixed(2);
        return format.replace(/\{\{\s*amount\s*\}\}/, amount);
      }
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode || 'USD'
      }).format(cents / 100);
    }

    function updatePrice(variant) {
      // 如果悬浮窗内部逻辑已处理价格(mtStickySelectedVariantId存在)，不再强制从主表单抓取覆盖
      if(window.mtStickySelectedVariantId) return; 

      if (variant) {
        if (priceElement && variant.price) priceElement.textContent = formatMoney(variant.price);
        if (comparePriceElement) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceElement.textContent = formatMoney(variant.compare_at_price);
            comparePriceElement.style.display = '';
          } else {
            comparePriceElement.style.display = 'none';
          }
        }
        if (productImage) {
          let imageUrl = null;
          if (variant.featured_media && variant.featured_media.preview_image) {
            imageUrl = variant.featured_media.preview_image.src || variant.featured_media.preview_image.url;
          } else if (variant.featured_image) {
            imageUrl = typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src || variant.featured_image.url;
          }
          if (imageUrl) {
            if (imageUrl.startsWith('//')) imageUrl = window.location.protocol + imageUrl;
            productImage.src = imageUrl;
            productImage.onerror = function() {
              if (defaultImageUrl && this.src !== defaultImageUrl) this.src = defaultImageUrl;
            };
          }
        }
      }
    }

    function getCurrentVariantFromPicker() {
      const variantPicker = document.querySelector('variant-picker[form-id="' + productFormIdForPicker + '"]');
      if (variantPicker) {
        const variantScript = variantPicker.querySelector('script[data-variant]');
        if (variantScript) {
          try { return JSON.parse(variantScript.textContent); } 
          catch (e) { console.error('Error parsing variant data:', e); }
        }
      }
      return null;
    }

    function getMainFormVariantInput() {
      if (mainForm) return mainForm.querySelector('input[name="id"]');
      return null;
    }

    function updateVariantId(variantId) {
      const mainVariantInput = getMainFormVariantInput();
      if (mainVariantInput) {
        mainVariantInput.value = variantId;
        if (mainVariantInput.disabled) mainVariantInput.disabled = false;
        mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    if (mainForm) {
      mainForm.addEventListener('variant:change', function(event) {
        const variant = event.detail?.variant;
        if (variant && variant.id) {
          updateVariantId(variant.id);
          setTimeout(() => updateBuyNowLink(variant.id), 50);
          updatePrice(variant);
        }
      });
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        triggerMainFormSubmit();
      });
    }

    let lastSyncedSrc = '';
    function syncImageFromSource() {
      const currentSourceImage = document.querySelector(sourceImageSelector);
      if (currentSourceImage && productImage) {
        let currentSrc = currentSourceImage.src || currentSourceImage.getAttribute('data-src');
        if (!currentSrc && currentSourceImage.srcset) {
          currentSrc = currentSourceImage.srcset.split(',')[0].trim().split(' ')[0];
        }
        if (currentSrc && currentSrc !== lastSyncedSrc && productImage.src !== currentSrc) {
          productImage.src = currentSrc;
          lastSyncedSrc = currentSrc;
        }
      }
    }

    function setupSourceImageListener() {
      const currentSourceImage = document.querySelector(sourceImageSelector);
      if (!currentSourceImage) { setTimeout(setupSourceImageListener, 500); return; }
      syncImageFromSource();
      const imageObserver = new MutationObserver((mutations) => {
          setTimeout(syncImageFromSource, 50);
      });
      imageObserver.observe(currentSourceImage, { attributes: true, attributeFilter:['src', 'srcset', 'data-src'], childList: true, subtree: true });
      setInterval(syncImageFromSource, 1000);
    }
    
    if(sourceImageSelector) setTimeout(setupSourceImageListener, 100);

    function initializeStickyBar() {
      if (window.mtStickySelectedVariantId) {
        updateBuyNowLink(window.mtStickySelectedVariantId);
        return;
      }
      const mainVariantInput = getMainFormVariantInput();
      if (mainVariantInput && mainVariantInput.value) {
        updateBuyNowLink(mainVariantInput.value);
      } else if (defaultVariantId) {
        updateVariantId(defaultVariantId);
        updateBuyNowLink(defaultVariantId);
      }
    }

    initializeStickyBar();
    setTimeout(initializeStickyBar, 500);
  }

  function initProductStickVisibility(config) {
    const { disappearClass } = config;
    const customProductPrice = document.querySelector(disappearClass ? '.' + disappearClass : '');
    const footerEl = document.querySelector('footer');
    const productStick = document.querySelector('.mt-product-stick');

    if (!productStick) return;

    let priceElementVisible = false;
    let footerVisible = false;

    function updateProductStickVisibility() {
      if (priceElementVisible || footerVisible) {
        productStick.classList.add('is-hidden');
      } else {
        productStick.classList.remove('is-hidden');
      }
    }

    if (customProductPrice) {
      const priceIO = new IntersectionObserver((entries) => {
          priceElementVisible = entries[0] && entries[0].isIntersecting;
          updateProductStickVisibility();
      });
      priceIO.observe(customProductPrice);
    }

    if (footerEl) {
      const footerIO = new IntersectionObserver((entries) => {
          footerVisible = entries[0] && entries[0].isIntersecting;
          updateProductStickVisibility();
      });
      footerIO.observe(footerEl);
    }
  }

  window.MTProductStick = {
    init: initProductStick,
    initVisibility: initProductStickVisibility
  };
})();